import React from 'react';
import { pendingTasks } from 'types';
import DialogConfirm from 'components/dialog/dialog-confirm';
import { Row } from 'components/layout/layout';
import { TDialogWrapperComponent } from 'components/dialog/index.types';
import useApprovePendingTask from '../hooks/use-approve-pending-task';
import { Body1 } from 'components/typography';

const DialogApprove = ({
    setIsDialogOpen,
    isDialogOpen,
    asyncStatesHandlers,
    data,
}: { data: pendingTasks.TPendingTasks } & TDialogWrapperComponent) => {
    const [onPendingTaskApprove] = useApprovePendingTask(asyncStatesHandlers);

  const pendingTaskId = data.id;
  return (
        <DialogConfirm<pendingTasks.TPendingTasks>
            isDialogOpen={data && isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            title={'Approve pending task'}
            onOk={async () => {
                if (!pendingTaskId) {
                    return;
                }
                try {
                    await onPendingTaskApprove({ id: pendingTaskId });
                } catch (e) {}
            }}
        >
            <Row>
                <Body1>Confirm APPROVE of pending task with id: { data.ekycId ?? pendingTaskId }</Body1>
            </Row>
        </DialogConfirm>
    );
};

export default DialogApprove;
